import SurveyAttr from "models/SurveyAttr";
import Question from "models/Question";
import Addition from "models/Addition";

// result set
export const SET_ATTR_RESULT = "answerResult/SET_ATTR_RESULT";
export const SET_ATTR_RESULT_BULK = "answerResult/SET_ATTR_RESULT_BULK";
export const SET_BASIC_RESULT = "answerResult/SET_BASIC_RESULT";
export const SET_BASIC_RESULT_BULK = "answerResult/SET_BASIC_RESULT_BULK";
export const CLEAR_TEMP_SAVED_DATA = "answerResult/CLEAR_TEMP_SAVED_DATA";
export const SET_ADDITION_RESULT_BULK = "answerResult/SET_ADDITION_RESULT_BULK";
export const SET_ADDITION_RESULT = "answerResult/SET_ADDITION_RESULT";
export const SET_OTHER_RESULT = "answerResult/SET_OTHER_RESULT";
export const SET_LOGIN_DT = "answerResult/SET_LOGIN_DT";
export const SET_LOCALE = "answerResult/SET_LOCALE";
// 自由記入のテキスト更新
export const CHANGE_FREE_COMMENT_TEXT = "answerResult/CHANGE_FREE_COMMENT_TEXT";
// 自由記入の編集フラグ
export const CHANGE_IS_EDIT_FREE_COMMENT_1 =
  "answerResult/CHANGE_IS_EDIT_FREE_COMMENT_1";
export const CHANGE_IS_EDIT_FREE_COMMENT_2 =
  "answerResult/CHANGE_IS_EDIT_FREE_COMMENT_2";
// attr edit dialog
export const OPEN_ATTR_EDIT_DIALOG = "answerResult/OPEN_ATTR_EDIT_DIALOG";
export const CLOSE_ATTR_EDIT_DIALOG = "answerResult/CLOSE_ATTR_EDIT_DIALOG";
export const SELECT_ATTR_ITEM = "answerResult/SELECT_ATTR_ITEM";
// basic edit dialog
export const OPEN_BASIC_EDIT_DIALOG = "answerResult/OPEN_BASIC_EDIT_DIALOG";
export const CLOSE_BASIC_EDIT_DIALOG = "answerResult/CLOSE_BASIC_EDIT_DIALOG";
export const SELECT_BASIC_ITEM = "answerResult/SELECT_BASIC_ITEM";
// addition edit dialog
export const OPEN_ADDITION_EDIT_DIALOG =
  "answerResult/OPEN_ADDITION_EDIT_DIALOG";
export const CLOSE_ADDITION_EDIT_DIALOG =
  "answerResult/CLOSE_ADDITION_EDIT_DIALOG";
export const SELECT_ADDITION_ITEM = "answerResult/SELECT_ADDITION_ITEM";
// other
export const SET_LOCALES = "answerResult/SET_LOCALES";
// For Develop
export const SET_DEVELOP_RESULT = "answerResult/SET_DEVELOP_RESULT";

// result set
export const setAttrResult = (surveyAttr, attrItem) => ({
  type: SET_ATTR_RESULT,
  surveyAttr,
  attrItem
});
export const setAttrResultBulk = (attrResult) => ({
  type: SET_ATTR_RESULT_BULK,
  attrResult
});
export const setBasicResult = (question, num) => ({
  type: SET_BASIC_RESULT,
  question,
  num
});
export const setBasicResultBulk = (basicResult) => ({
  type: SET_BASIC_RESULT_BULK,
  basicResult,
});
export const setAdditionResult = (addition, choice) => ({
  type: SET_ADDITION_RESULT,
  addition,
  choice
});
export const setAdditionResultBulk = (additionResult) => ({
  type: SET_ADDITION_RESULT_BULK,
  additionResult,
});
export const setOtherResult = freeComment => ({
  type: SET_OTHER_RESULT,
  freeComment
});
export const setLoginDt = loginDt => ({
  type: SET_LOGIN_DT,
  loginDt
});
export const setLocale = localeId => ({
  type: SET_LOCALE,
  localeId
});
export const changeFreeCommentText = (key, text) => ({
  type: CHANGE_FREE_COMMENT_TEXT,
  key,
  text
});
export const changeIsEditFreeCommnet1 = flg => ({
  type: CHANGE_IS_EDIT_FREE_COMMENT_1,
  flg
});
export const changeIsEditFreeCommnet2 = flg => ({
  type: CHANGE_IS_EDIT_FREE_COMMENT_2,
  flg
});
export const clearTempSavedData = () => ({
  type: CLEAR_TEMP_SAVED_DATA
});

// attr edit dialog
export const openAttrEditDialog = surveyAttr => ({
  type: OPEN_ATTR_EDIT_DIALOG,
  surveyAttr: new SurveyAttr(surveyAttr)
});
export const closeAttrEditDialog = () => ({
  type: CLOSE_ATTR_EDIT_DIALOG
});
export const selectAttrItem = attrItem => ({
  type: SELECT_ATTR_ITEM,
  attrItem
});

// basic edit dialog
export const openBasicEditDialog = question => ({
  type: OPEN_BASIC_EDIT_DIALOG,
  question: new Question(question)
});
export const closeBasicEditDialog = () => ({
  type: CLOSE_BASIC_EDIT_DIALOG
});
export const selectBasicItem = num => ({
  type: SELECT_BASIC_ITEM,
  num
});

// basic edit dialog
export const openAdditionEditDialog = addition => ({
  type: OPEN_ADDITION_EDIT_DIALOG,
  addition: new Addition(addition)
});
export const closeAdditionEditDialog = () => ({
  type: CLOSE_ADDITION_EDIT_DIALOG
});
export const selectAdditionItem = choice => ({
  type: SELECT_ADDITION_ITEM,
  choice
});

// other
export const setLocales = surveyLocales => ({
  type: SET_LOCALES,
  locales: surveyLocales.map(sl => sl.locale)
});

// For Develop
export const setDevelopResult = (qNo, aNo) => ({
  type: SET_DEVELOP_RESULT,
  qNo,
  aNo
});

const initialState = {
  locale: null,
  attrResult: {},
  basicResult: {},
  additionResult: {},
  freeComment1: "",
  freeComment2: "",
  isEditFreeComment1: false,
  isEditFreeComment2: false,
  loginDt: "",
  attrEditDialog: {
    open: false,
    surveyAttr: new SurveyAttr(),
    attrItem: {},
    selectedAttrItem: {}
  },
  basicEditDialog: {
    open: false,
    question: new Question(),
    selectedNum: ""
  },
  additionEditDialog: {
    open: false,
    addition: new Addition(),
    selectedChoice: {}
  },
  locales: [] // 基本設問の選択肢文言の切り替え用
};

const answerResult = (state = initialState, action = {}) => {
  switch (action.type) {
    // set result
    case SET_ATTR_RESULT: {
      const { surveyAttr, attrItem } = action;
      const { order } = surveyAttr;
      const result = { surveyAttr, attrItem };
      const attrResult = { ...state.attrResult, [order]: result };

      return { ...state, attrResult };
    }
    case SET_ATTR_RESULT_BULK: {
      return {
        ...state,
        attrResult: action.attrResult
      };
    }
    case SET_BASIC_RESULT: {
      const { question, num } = action;
      const { qNo } = question;
      const result = { question, num };
      const basicResult = { ...state.basicResult, [qNo]: result };

      return { ...state, basicResult };
    }
    case SET_BASIC_RESULT_BULK: {
      return {
        ...state,
        basicResult: action.basicResult,
      };
    }
    case SET_ADDITION_RESULT: {
      const { addition, choice } = action;
      const { qNo } = addition;
      const result = { addition, choice };
      const additionResult = { ...state.additionResult, [qNo]: result };

      return { ...state, additionResult };
    }
    case SET_ADDITION_RESULT_BULK: {
      return {
        ...state,
        additionResult: action.additionResult,
      };
    }
    case SET_LOGIN_DT: {
      return { ...state, loginDt: action.loginDt };
    }
    case SET_LOCALE: {
      const { localeId } = action;
      const locale = state.locales.find(l => l.id === localeId);
      return { ...state, locale };
    }
    case CHANGE_FREE_COMMENT_TEXT: {
      const { key, text } = action;

      // keyはfreeComment1かfreeComment2
      return { ...state, [key]: text };
    }
    case CHANGE_IS_EDIT_FREE_COMMENT_1: {
      const isEditFreeComment1 = action.flg;
      return { ...state, isEditFreeComment1 };
    }
    case CHANGE_IS_EDIT_FREE_COMMENT_2: {
      const isEditFreeComment2 = action.flg;
      return { ...state, isEditFreeComment2 };
    }

    // attr edit dialog
    case OPEN_ATTR_EDIT_DIALOG: {
      const { surveyAttr } = action;
      const selectedAttrItem = state.attrResult[surveyAttr.order].attrItem;
      const attrEditDialog = { open: true, surveyAttr, selectedAttrItem };

      return { ...state, attrEditDialog };
    }
    case CLOSE_ATTR_EDIT_DIALOG: {
      const attrEditDialog = { ...state.attrEditDialog, open: false };

      return { ...state, attrEditDialog };
    }
    case SELECT_ATTR_ITEM: {
      const selectedAttrItem = action.attrItem;
      const attrEditDialog = { ...state.attrEditDialog, selectedAttrItem };

      return { ...state, attrEditDialog };
    }

    // Basic Edit Dialog
    case OPEN_BASIC_EDIT_DIALOG: {
      const { question } = action;
      const selectedNum = state.basicResult[question.qNo].num;
      const basicEditDialog = { open: true, question, selectedNum };

      return { ...state, basicEditDialog };
    }
    case CLOSE_BASIC_EDIT_DIALOG: {
      const basicEditDialog = { ...state.basicEditDialog, open: false };

      return { ...state, basicEditDialog };
    }
    case SELECT_BASIC_ITEM: {
      const selectedNum = action.num;
      const basicEditDialog = { ...state.basicEditDialog, selectedNum };

      return { ...state, basicEditDialog };
    }

    // Addition Edit Dialog
    case OPEN_ADDITION_EDIT_DIALOG: {
      const { addition } = action;
      const selectedChoice = state.additionResult[addition.qNo].choice;
      const additionEditDialog = { open: true, addition, selectedChoice };

      return { ...state, additionEditDialog };
    }
    case CLOSE_ADDITION_EDIT_DIALOG: {
      const additionEditDialog = { ...state.additionEditDialog, open: false };

      return { ...state, additionEditDialog };
    }
    case SELECT_ADDITION_ITEM: {
      const selectedChoice = action.choice;
      const additionEditDialog = {
        ...state.additionEditDialog,
        selectedChoice
      };

      return { ...state, additionEditDialog };
    }

    case CLEAR_TEMP_SAVED_DATA: {
      return {
        ...state,
        attrResult: {},
        basicResult: {},
        additionResult: {},
        freeComment1: "",
        freeComment2: "",
      };
    }

    // Other
    case SET_LOCALES: {
      const { locales } = action;
      return { ...state, locales };
    }

    // For Develop
    case SET_DEVELOP_RESULT: {
      const basicResult = {};

      const arr = [...Array(action.qNo).keys()];
      arr.forEach(n => {
        const qNo = n + 1;

        basicResult[qNo] = {
          question: {
            qNo,
            title: "",
            text: `設問 ${qNo}`
          },
          num: action.aNo
        };
      });

      return { ...state, basicResult };
    }

    default:
      return state;
  }
};

export default answerResult;



// WEBPACK FOOTER //
// ./src/redux/modules/answer/answerResult.js